import { find } from 'lodash';

export const AVAILABLE_TIMESPANS = {
  TODAY: {
    parameter: 'TODAY',
    name: 'Today',
  },
  '3DAY': {
    parameter: '3DAY',
    name: '3 Days',
  },
  WEEK: {
    parameter: 'WEEK',
    name: 'Week',
  },
  MONTH: {
    parameter: 'MONTH',
    name: 'Month',
  },
  ALL: {
    parameter: 'ALL',
    name: 'All Time',
  },
  EMPTY: {
    parameter: '',
    name: '',
  },
};

export const DEFAULT_TIMESPANS = {
  movers: AVAILABLE_TIMESPANS.TODAY,
  traded: AVAILABLE_TIMESPANS.ALL,
};

export const DEFAULT_TIMESPANS_MARKETS = {
  ...DEFAULT_TIMESPANS,
  traded: AVAILABLE_TIMESPANS.TODAY,
};

export const ORDERS = [
  {
    name: 'Volume',
    fullName: 'Trade Volume',
    sort: 'traded',
  },
  {
    name: 'Price',
    fullName: 'Price Change',
    sort: 'movers',
  },
  {
    name: 'New Arrivals',
    fullName: 'New Arrivals',
    sort: 'newest',
  },
  {
    name: 'Expiring',
    fullName: 'Expiring',
    sort: 'closing',
  },
  {
    name: 'Investment',
    fullName: 'Investment',
    sort: 'investment',
  },
  {
    name: 'Gain',
    fullName: 'Gain',
    sort: 'gain',
  },
  {
    name: 'Loss',
    fullName: 'Loss',
    sort: 'loss',
  },
];

export const ORDERS_WITH_TIMESPAN_FILTER = ['movers', 'traded'];

export const TIMESPANS = [
  AVAILABLE_TIMESPANS.TODAY,
  AVAILABLE_TIMESPANS['3DAY'],
  AVAILABLE_TIMESPANS.WEEK,
  AVAILABLE_TIMESPANS.MONTH,
  AVAILABLE_TIMESPANS.ALL,
];

export const selectTimespan = (state, parameter) => {
  state.selectedTimespan = find(state.timespans, { parameter });
};

export const selectOrder = (state, sort) => {
  state.selectedOrder = find(state.orders, { sort });
  state.selectedTimespan = DEFAULT_TIMESPANS_MARKETS[sort] || AVAILABLE_TIMESPANS.EMPTY;
  state.shouldShowTimespanFilter = ORDERS_WITH_TIMESPAN_FILTER
    .indexOf(state.selectedOrder.sort) !== -1;
};



// WEBPACK FOOTER //
// ./src/store/modules/filters_consts.js